
/*export const environment = {
    production: false,
    serverPath: "http://localhost:61002",
    // serverPath: "http://160.40.54.150:19999/rest",
    defaultLang: "en",
    dateDefaultFormat: "YYYY-MM-DD",
    defaultUsername: "",
    defaultPassword: "",
    socketsPath: "ws://localhost:61003/",
    socialPath:"",
    authenticationServer: "http://localhost:61002",
    sockets: {
      url: "/",
      path: "/ws",
      transports: ["websocket"],
    },
    daysForConsentExpirationNotification: 5,
    demoCredentials: {
      // doctor
      email: "imp_01@digicare.al",
      password: "123"
      // patient
      // email: "patient@example.com",
      // password: "Password123",
      // email: "doctor1@itihealth.com",
      // password: "123",
    },
    analysisDemo: true,
  }; */
  export const environment = {
    production: true,
    serverPath: "/rest",
    defaultLang: "en",
    dateDefaultFormat: "YYYY-MM-DD",
    //authenticationServer: "http://160.40.51.25:61002",
    //socketsPath: "ws://160.40.51.25:61003/",
    authenticationServer: "/rest",
    socketsPath: "/ws",
    sockets: {
      url: "/",
      path: "/ws",
      transports: ["websocket"],
    },
    defaultUsername:"",
    defaultPassword:"",
    daysForConsentExpirationNotification: 7,
    demoCredentials: {
      email: "",
      password: "",
    },
    analysisDemo: true,
  };
  